<template>
    <div id="quickyear">
        <div class="recharge">
            <h1>包年看书<span class="red">365</span>元</h1>
            <h1>尊享<span class="red">无限畅读</span>体验</h1>
            <h1>全站书籍<span class="red">免费看一年</span></h1>
            <ul>
                <li :class="{active:type == 6}" @click="type = 6">
                    <img src="http://static.yuread.cn/quick/wechat.png" alt=""> 微信充值
                </li>
                <li :class="{active:type == 7}" @click="type = 7">
                    <img src="http://static.yuread.cn/quick/zfb.png" alt=""> 支付宝
                </li>
            </ul>
            <button @click="doRecharge">立即充值</button>
        </div>

        <div class="tip">
            <h6>活动规则：</h6>
            <p>1.此充值为开通年费服务;</p>
            <p> 2.年费服务为虚拟充值，一经购买不支持退货;</p>
            <p> 3.活动最终解释权归网站所有;</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Year",
        data(){
            return {
                active : 1,
                type : 6,
            }
        },
        methods : {
            doRecharge(){
                system.postMessage(JSON.stringify({
                    active : 1,
                    type : this.type
                }))
            }
        },
        created(){
        },
        mounted(){
            // let that = this;
            // system.onmessage =  (data) =>{
            //     alert(data);
            // }

        },

    }
</script>

<style lang="less">
#quickyear{padding:40px;background-color:#FC4242;background-image: url("http://static.yuread.cn/quick/year.png");background-size:100% ;overflow: auto;
    .recharge{width: 100%;padding:40px;background: #fff;border-radius: 42px;margin-top: 700px;
        h1{color: #0f0f0f;font-size: 46px;width: 100%;text-align: center;font-weight: 400;}
        .red{color: #fc0001;}

        ul{justify-content: space-between;flex-direction: row;display: flex;margin: 50px 0;
            li{border: 1px solid #D1D1D1;border-radius: 12px;width: 280px;padding: 24px;font-size: 32px;color: #383839;display: flex;justify-content: center;
                img{height: 40px;width: 40px;margin-right: 10px;}
            }
            .active{border-color: #ffa43e;}

        }
        button{margin: 0 auto;display: block;width: 502px;height: 100px;background: linear-gradient(90deg, #FE893E 0%, #FF4236 100%);box-shadow: 0px 4px 20px 0px #FF5037;border-radius: 50px;border: none;font-size: 40px;color: #FFFFFF;
        }
    }

    .tip{margin-top: 50px;color: #fff;
        h6{font-size: 32px;}
        p{font-size: 28px;}
    }


}
</style>
